import { Loader2Icon } from "lucide-react";
import type React from "react";
import { cn } from "@/lib/utils";

export function Spinner({
  className,
  ...props
}: React.ComponentProps<typeof Loader2Icon>): React.ReactElement {
  return (
    <Loader2Icon
      aria-label="Loading"
      className={cn("animate-spin", className)}
      role="status"
      {...props}
    />
  );
}

/**
 * Loader a pantalla completa, centrado. Para los guards de carga de página
 * (mientras resuelve la sesión, antes de montar el shell). Reemplaza el viejo
 * texto "Cargando…" suelto en la esquina superior izquierda.
 */
export function PageLoader({ className }: { className?: string }): React.ReactElement {
  return (
    <div className={cn("flex min-h-screen w-full items-center justify-center", className)}>
      <Spinner className="size-8 text-muted-foreground" />
    </div>
  );
}
